import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Submission } from "./Submission";
import { ISubmittals } from "../../../models/Submittals";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Checkbox } from "primereact/checkbox";
import { IUserMast } from "../../../models/UserMast";
import { Button } from "primereact/button";
import { IConsultantMast } from "../../../models/ConsultantMast";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { Steps } from "primereact/steps";
import { IEmailTemplate } from "../../../models/EmailTemplate";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { format } from "date-fns";
import { RecruiterUnderstandingForm } from "./RecruiterUnderstandingForm";
import { Tooltip } from "primereact/tooltip";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";



interface Iprops {
    req_id?: number,
    submission_id?: ISubmittals,
    job_Title?: string,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

interface I_JD_Resume_Matching {
    id?: number,
    Submission_id?: number,
    SkillsMatchPercentage?: number,
    ExperienceMatchPercentage?: number,
    OverallMatchPercentage?: number,
    ShortExplanation?: string,
    Added_By?: string | number,
    Added_On?: Date,
}

export const SubmissionsTable = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISubmittals>, loading: boolean });
    const [tableDataSub, setTableDataSub] = useState({ tableData: [], loading: false } as { tableData: Array<I_JD_Resume_Matching>, loading: boolean });
    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [innerDialogVisible, setInnerDialogVisible] = useState(false);
    const [mailBody, setMailBody] = useState<string>("");
    const [Signature, setSignature] = useState<string>("");
    const [issendmail, setIssendmail] = useState(false);
    const [anyCheckboxChecked, setAnyCheckboxChecked] = useState(false);
    const [openRecruiterUnderstanding, setOpenRecruiterUnderstanding] = useState({ singleData: {}, open: false } as { singleData: ISubmittals | any, open: boolean });
    const [openSubmissionMatching, setOpenSubmissionMatching] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });



    const [submission, setSubmission] = useState({ open: false } as {
        recruiter?: string,
        submission_id?: number,
        req_id?: number,
        cons_id?: number,
        vendor_Company_ID?: number,
        status?: number,
        open: boolean,
        recruiterID: number,
    });

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<any>({
        // resolver: yupResolver(schema),
        defaultValues: "",
        shouldFocusError: false
    });
    const hideSubmissionDialog = () => {
        setSubmission({
            recruiter: undefined,
            req_id: undefined,
            cons_id: undefined,
            status: undefined,
            open: false,
            recruiterID: 0,
        });
    };

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("ECI/allSubmitals", "GET", null, `req_id=${props.req_id}`, props.toast);
        if (response) {
            const data: Array<ISubmittals> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: [], loading: false });
    }

    useEffect(() => {
        if (props.req_id) loadTableData();
    }, [props.req_id]);

    const submission_id = (rowData: ISubmittals) => {
        return <div className='cursor-pointer text-cyan-700 underline' onClick={() => setSubmission({
            open: true, submission_id: rowData.submission_id, cons_id: rowData.consultant_ID,
            recruiter: rowData.user_Name, req_id: rowData.req_ID,
            vendor_Company_ID: rowData.vendor_Company_ID, status: rowData.req_Service_Status, recruiterID: rowData?.login_ID || 0
        })}>{rowData.submission_id}</div>
    }

    const generateMail = async (submission_id?: number) => {
        console.log(submission_id);
        const data: Array<number> = [];
        tableData.tableData.forEach(e => {
            if ((e.is_sendMail && e.submission_id !== 0)) {
                data.push(e.submission_id);
            }
        });
        const response = await Fetch("Consultant_Mast/byName", "POST", data, null, props.toast);
        try {
            const response = await Fetch("Consultant_Mast/byName", "POST", data, null, props.toast);
            if (response) {
                const mailData = await response.json();
                setMailBody(mailData.emailBody);
                setSignature(mailData.signature);
                // console.log(mailBody);
            }
        } catch (error) {
            console.error("Error generating mail:", error);
            props.toast.current.show({ severity: 'error', detail: "Error generating mail.", life: 3000 });
        }
    }


    const saveToDB = async () => {
        setLoading(true);
        const data: Array<number> = [];
        tableData.tableData.forEach(e => {
            if (e.is_sendMail && e.submission_id !== 0) {
                data.push(e.submission_id);
            }
        });
        const body = {
            submission_id: data,
            emailTemp: mailBody,
            signature: Signature
        };

        const response = await Fetch("Consultant_Mast/SendSubmissionMail", "POST", body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
        }

    }


    const onCheckChange = (submission_id?: number) => {
        let data = [...tableData.tableData];
        if (submission_id !== undefined) {
            for (var i in data) {
                if (data[i].submission_id === submission_id) {
                    data[i].is_sendMail = !data[i].is_sendMail;
                    break;
                }
            }
        }
        setTableData({ ...tableData, tableData: data });
        setIssendmail(true);
        const isChecked = data.some(item => item.is_sendMail);
        setAnyCheckboxChecked(isChecked);
    }

    const sendMessage = (rowData: ISubmittals) => {
        return (rowData.status_Name == "Accepted by Sales Manager" && (rowData.mailToSendPV == false || rowData.mailToSendPV == null) ? <div>
            <Checkbox onChange={() => onCheckChange(rowData?.submission_id)} name={rowData.submission_id?.toString()} checked={rowData?.is_sendMail} ></Checkbox>
        </div> : "")
    }

    const sendMessage1 = (rowData: ISubmittals) => {
        return (rowData.mailToSendPV ? <div className="flex flex-row justify-content-between align-items-center" >
            <p className=" underline" style={{ color: "red", fontWeight: "bolder" }}>Mail Send To PV</p>

        </div> : "")
    }

    const onHide = () => {
        props.hideDialog();
        setInnerDialogVisible(false);
        setIssendmail(false);
        setAnyCheckboxChecked(false);

    }

    const onSubmit = (rowData: ISubmittals | any) => {

        if (!anyCheckboxChecked) {
            props.toast.current.show({ severity: 'error', detail: "Please select a submission to send an email.", life: 3000 });
            return;
        } else {
            setInnerDialogVisible(true);
            generateMail();
        }
    }

    const footerTemplate = () => {
        return (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                <>
                    {anyCheckboxChecked && <><Button className="p-button-sm my-1" label="SUBMIT" type="button" onClick={onSubmit}></Button>
                        <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide}></Button></>}
                </>
            </div>
        );
    }

    const mailSendDate = (rowData: ISubmittals) => {
        let date;
        if (rowData.mail_Send_DateTime) date = format(new Date(rowData.mail_Send_DateTime), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const getVisaCopy = (rowData: ISubmittals) => {
        let date;
        if (rowData.visa_Received_Path === undefined || rowData.visa_Received_Path === null || rowData.visa_Received_Path.trim() === "") return <></>;
        return (<p className="cursor-pointer text-cyan-700 underline" onClick={() => downloadVisaCopy(rowData)}>Download</p>);
    };

    const downloadVisaCopy = async (rowData: ISubmittals) => {
        const params = {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"ECI/downloadSubmittalVisaCopy"}?submissionID=${rowData.submission_id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();

                const disposition = response.headers.get("content-disposition");
                let fileName = `${rowData.consultant_Name}_Visa_Copy`;

                if (disposition) {
                    const match = disposition.match(/filename="?([^"]+)"?/);
                    if (match?.[1]) {
                        fileName = match[1];
                    }
                }

                const href = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = href;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(href);
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const hideInnerDialog = () => {
        setInnerDialogVisible(false);
    };

    const loadTableDataMatching = async (subID: number) => {
        setTableDataSub({ tableData: [], loading: true });
        const response = await Fetch("Consultant_Mast/getSubmissionResumeJDMatching", "GET", null, `subID=${subID}`, props.toast);
        if (response) {
            const data: Array<I_JD_Resume_Matching> = await response.json();
            setTableDataSub({ tableData: data, loading: false });
        } else setTableDataSub({ tableData: [], loading: false });
    }

    const recruiterUnderstandings = (rowData: ISubmittals) => {
        return (<Button className="p-button-rounded" type="button" tooltip="View Recruiter Requirement Understandings" icon="pi pi-eye" onClick={() => {
            setOpenRecruiterUnderstanding({ singleData: rowData, open: true });
        }}></Button>)
    };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DataFormat = loginObj.date_Format;

    return (

        <Dialog visible={props.open} style={{ width: '80vw' }} header={`Submissions for Req - ${props.req_id} (${props.job_Title})`} className="p-fluid" draggable={false} footer={footerTemplate} onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                stripedRows showGridlines responsiveLayout="scroll"
                value={tableData.tableData}
                loading={tableData.loading}
            >

                {/* <JVCheckbox column={2} label="No Auto Allocation" control={control} name="no_Auto_Allocation" /> */}
                <Column body={sendMessage} />
                <Column field="submission_id" header="Submission ID" body={submission_id} />
                <Column field="consultant_Name" header="Consultant" />
                <Column field="user_Name" header="Recruiter" />
                <Column field="buying_Rate" header="Buying Rate" />
                <Column field="req_Service_Status_Name" header="Submission Status" body={(rowData: ISubmittals) => rowData?.req_Service_Status_Name ? rowData?.req_Service_Status_Name : <span className="text-cyan-700">Submitted by Recruiter</span>} />
                <Column field="" header="Download Visa" body={getVisaCopy} />
                {/* <Column field="submitalDate" header="Submission Date" /> */}
                <Column field="submitalDate" header="Submission Date" body={(rowData: any) => safeFormatDate(rowData.submitalDate, 'dd/MM/yyyy', DataFormat)} />
                <Column field="" header="" body={sendMessage1} />
                {<Column field="" header="Mail Send On" body={mailSendDate} />}
                <Column field="req_Understand_Percentage" header="Understanding %" />
                <Column field="req_Understood_Comment" header="What Understood" body={(rowData: any) => <div className="flex"><div className="knob" style={{ color: "#2196F3", cursor: "pointer", height: "20px", width: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{rowData?.req_Understood_Comment}<Tooltip target=".knob" position="top" content={`${rowData?.req_Understood_Comment || ""}`} /></div><span style={{ color: "#2196F3", marginLeft: "-10px" }}>{((rowData?.req_Understood_Comment?.trim() || "")).length > 5 ? "..." : ""}</span></div>} />
                <Column field="understood_Audio_Path" header="What Understood Audio" body={(rowData: ISubmittals) => {
                    if (rowData?.understood_Audio_Path !== null && rowData?.understood_Audio_Path !== undefined && (rowData?.understood_Audio_Path || "").trim() !== "") {
                        return <audio controls style={{ width: '100%' }}>
                            <source src={baseUrl + `Calling_Extension/streamReqUnderstandingAudio2?subID=${rowData?.submission_id}&fileName=${rowData?.understood_Audio_Path}`} type="audio/webm" />
                            Your browser does not support the audio element.
                        </audio>
                    } else return <></>

                }} />
                <Column field="" header="Resume JD Match" body={(rowData: ISubmittals) => <p className='cursor-pointer text-cyan-700 underline' onClick={() => {
                    loadTableDataMatching(rowData?.submission_id);
                    setOpenSubmissionMatching({ singleData: rowData, open: true });
                }}>view</p>} />
                {/* <Column field="" header="Recruiter Understanding" body={recruiterUnderstandings} /> */}


            </DataTable>
            {/* <Dialog header="Header" visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}></Dialog> */}

            <Dialog header="" visible={innerDialogVisible} style={{ width: '50vw' }} onHide={hideInnerDialog}>
                <div className="col-12 md:col-12 md:col-12">
                    <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                        <label>Email Body</label>
                        <div className="m-1">
                            {/* <Button label="Fill Email Body" type="button" icon="pi pi-envelope" className="p-button p-button-danger" onClick={generateMail} /> */}
                        </div>
                    </div>
                    {/* <JVSunEditor value={mailBody} handleChange={setMailBody} /> */}
                    <CKEditor editor={ClassicEditor} data={mailBody} onChange={(event, editor) => { setMailBody(editor.getData()); }} />

                </div>
                <div className="col-12 md:col-12 md:col-12">
                    <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                        <label>Signature</label>
                        <div className="m-1">
                            <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-text" />
                        </div>
                    </div>
                    {/* <JVSunEditor value={Signature} handleChange={setSignature}/> */}
                    <CKEditor editor={ClassicEditor} data={Signature} onChange={(event, editor) => { setSignature(editor.getData()); }} />

                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                        <> <Button className="p-button-sm my-1" label="SEND" type="button" onClick={saveToDB}></Button>
                            <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide}></Button></>
                    </div>
                    {/* <div className="field col-12 md:col-12">
                        <Button className="className=field col-12 md:col-6 p-button-outlined" onClick={() => setActiveIndex(activeIndex - 1)} label='PREVIOUS'></Button>
                        <Button className="field col-12 md:col-6 mt-3" loading={loading} label="SAVE" type="submit"></Button>
                        <Button className="className=field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div> */}

                </div>
            </Dialog>

            <Dialog header="Job Description & Resume Matching %" visible={openSubmissionMatching.open} style={{ width: '50vw' }} onHide={() => setOpenSubmissionMatching({ singleData: {}, open: false })}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small"
                    stripedRows showGridlines responsiveLayout="scroll"
                    value={tableDataSub.tableData}
                    loading={tableDataSub.loading}
                >
                    <Column field="skillsMatchPercentage" header="Skills Match %" />
                    <Column field="experienceMatchPercentage" header="Experience Match %" />
                    <Column field="overallMatchPercentage" header="Overall Match %" />
                    <Column field="shortExplanation" header="Short Explanation" />
                </DataTable>
            </Dialog>





            <Submission recruiter={submission.recruiter} vendor_Company_ID={submission.vendor_Company_ID} submission_id={submission.submission_id} req_id={submission.req_id} cons_id={submission.cons_id} status={submission.status} open={submission.open} hideDialog={hideSubmissionDialog} toast={props.toast} reload={props.reload} setReload={props.setReload} hideDialogP={props.hideDialog} recruiterID={submission.recruiterID} />
            <RecruiterUnderstandingForm open={openRecruiterUnderstanding.open} singleData={openRecruiterUnderstanding.singleData} hideDialog={() => setOpenRecruiterUnderstanding({ open: false, singleData: {} })} toast={props.toast} />
        </Dialog>

    );
}